/*!
 * Copyright 2023 Thorne Health Lab. All rights reserved.
 */

import React from 'react'
import RangeChart from './ChartComponents/Range'
import { normalizeData } from '../../../utils'
import LinkIcon from './OutboundLinkComponent'
import PropTypes from 'prop-types'
import List from '../../../components/List'

class Laboratory extends React.Component {
  constructor(props) {
    super(props)

    // const {details} = this.props

    // getinitialState
    this.state = {
      sodiumData: this.SodiumData(),
      potassium: this.PotassiumData(),
      chloride: this.ChlorideData(),
      biocarbonate: this.BioCarbData(),
      calcium: this.CalciumData(),
      urea: this.UreaData(),
      creatinine: this.CreatinineData(),
      glucose: this.Glucose(),
      tp: this.TPData(),
      alb: this.AlbData(),
      ast: this.ASTData(),
      alt: this.ALTData(),
      alp: this.ALPData(),
      tbil: this.TbilData(),
      cholesterol: this.CholData(),
      hdl: this.HDLData(),
      chdl: this.CHDLData(),
      ldl: this.LDLData(),
      trig: this.TrigData(),
      vldl: this.VLDLData()
    }
  }

  componentDidUpdate() {
    const el = document.querySelectorAll('.cat-container a')

    for (let i = 0; i < el.length; i++) {
      el[i].addEventListener('click', function(e) {
        e.stopPropagation()
      })
    }
  }

  UNSAFE_componentWillReceiveProps() {
    this.setState({
      sodiumData: this.SodiumData(),
      potassium: this.PotassiumData(),
      chloride: this.ChlorideData(),
      biocarbonate: this.BioCarbData(),
      calcium: this.CalciumData(),
      urea: this.UreaData(),
      creatinine: this.CreatinineData(),
      glucose: this.Glucose(),
      tp: this.TPData(),
      alb: this.AlbData(),
      ast: this.ASTData(),
      alt: this.ALTData(),
      alp: this.ALPData(),
      tbil: this.TbilData(),
      cholesterol: this.CholData(),
      hdl: this.HDLData(),
      chdl: this.CHDLData(),
      ldl: this.LDLData(),
      trig: this.TrigData(),
      vldl: this.VLDLData()
    })
  }

  SodiumData() {
    const { details } = this.props
    const data = details.electrolytes['sodium-na']
    const normalData = normalizeData(data)

    return normalData
  }

  PotassiumData() {
    const { details } = this.props
    const data = details.electrolytes['potassium-k']
    const normalData = normalizeData(data)

    return normalData
  }

  ChlorideData() {
    const { details } = this.props
    const data = details.electrolytes['chloride-cl']
    const normalData = normalizeData(data)

    return normalData
  }

  BioCarbData() {
    const { details } = this.props
    const data = details.electrolytes['bicarbonate-t-co-2']
    const normalData = normalizeData(data)

    return normalData
  }

  CalciumData() {
    const { details } = this.props
    const data = details.electrolytes['calcium-ca-2']
    const normalData = normalizeData(data)

    return normalData
  }

  UreaData() {
    const { details } = this.props
    const data = details.kidney_function['blood-urea-nitrogen-bun']
    const normalData = normalizeData(data)

    return normalData
  }

  CreatinineData() {
    const { details } = this.props
    const data = details.kidney_function['creatinine-cre']
    const normalData = normalizeData(data)

    return normalData
  }

  Glucose() {
    const { details } = this.props
    const data = details.metabolism['glucose-glu']
    const normalData = normalizeData(data)

    return normalData
  }

  TPData() {
    const { details } = this.props
    const data = details.liver_function.tp
    const normalData = normalizeData(data)

    return normalData
  }

  AlbData() {
    const { details } = this.props
    const data = details.liver_function.alb
    const normalData = normalizeData(data)

    return normalData
  }

  ASTData() {
    const { details } = this.props
    const data = details.liver_function.ast
    const normalData = normalizeData(data)

    return normalData
  }

  ALTData() {
    const { details } = this.props
    const data = details.liver_function.alt
    const normalData = normalizeData(data)

    return normalData
  }

  ALPData() {
    const { details } = this.props
    const data = details.liver_function.alp
    const normalData = normalizeData(data)

    return normalData
  }

  TbilData() {
    const { details } = this.props
    const data = details.liver_function.tbil
    const normalData = normalizeData(data)

    return normalData
  }

  CholData() {
    const { details } = this.props
    const data = details.lipids.cholesterol
    const normalData = normalizeData(data)

    return normalData
  }

  HDLData() {
    const { details } = this.props
    const data = details.lipids.hdl
    const normalData = normalizeData(data)

    return normalData
  }

  CHDLData() {
    const { details } = this.props
    const data = details.lipids['cholesterol-hdl']
    const normalData = normalizeData(data)

    return normalData
  }

  LDLData() {
    const { details } = this.props
    const data = details.lipids.ldl
    const normalData = normalizeData(data)

    return normalData
  }

  TrigData() {
    const { details } = this.props
    const data = details.lipids.trig
    const normalData = normalizeData(data)
    return normalData
  }

  VLDLData() {
    const { details } = this.props
    const data = details.lipids.vldl
    const normalData = normalizeData(data)

    return normalData
  }

  render() {
    const { details, index, hotload } = this.props

    const items = {
      physicalActivity: {
        title: '<h2 class="mobile-padding">Laboratory</h2>'
      }
    }
    const listProps = {
      items,
      isMobile: this.props.isMobile,
      isNoTopBorder: true,
      isNotSpacer: true,
      isCollapsedDark: true,
      isReportStyle: true
    }

    return (
      <div className="laboratory-content module-content">
        {this.props.isMobile && <List {...listProps} />}

        {hotload ? (
          <div className="mobile-padding">
            <div className="lab-group">
              <div className="table">
                <a
                  href="https://medlineplus.gov/ency/article/002350.htm"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <strong className="subject">Electrolytes</strong>
                  <LinkIcon />
                </a>

                <br />

                {this.props.isMobile && <hr />}
                {!this.props.isMobile && <br />}

                {/* Chloride */}
                <div className="trow">
                  <div className="td">
                    <strong className="subject" />
                  </div>
                  <div className="td td-border-top">
                    <strong className="value">
                      {details.electrolytes['chloride-cl'].display_label}
                    </strong>
                    <span className="descriptor">
                      {details.electrolytes['chloride-cl'].interpretation}
                    </span>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <RangeChart
                        details={details}
                        index={index}
                        label={'Chloride'}
                        data={this.state.chloride}
                      />
                      {!details.electrolytes['chloride-cl'].__ok ? (
                        <div className="no-report-data">
                          {`No Data Available`}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <strong className="value">
                        {details.electrolytes['chloride-cl'].value}
                      </strong>
                      <span className="descriptor">
                        {details.electrolytes['chloride-cl'].unit}
                      </span>
                      {!details.electrolytes['chloride-cl'].__ok ? (
                        <div className="no-report-data" />
                      ) : null}
                    </div>
                  </div>
                </div>

                {/* Potassium */}
                <div className="trow">
                  <div className="td">
                    <strong className="subject" />
                  </div>
                  <div className="td td-border-top">
                    <strong className="value">
                      {details.electrolytes['potassium-k'].display_label}
                    </strong>
                    <span className="descriptor">
                      {details.electrolytes['potassium-k'].interpretation}
                    </span>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <RangeChart
                        details={details}
                        index={index}
                        label={'Potassium'}
                        data={this.state.potassium}
                      />
                      {!details.electrolytes['potassium-k'].__ok ? (
                        <div className="no-report-data">
                          {`No Data Available`}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <strong className="value">
                        {details.electrolytes['potassium-k'].value}
                      </strong>
                      <span className="descriptor">
                        {details.electrolytes['potassium-k'].unit}
                      </span>
                      {!details.electrolytes['potassium-k'].__ok ? (
                        <div className="no-report-data" />
                      ) : null}
                    </div>
                  </div>
                </div>

                {/* Sodium */}
                <div className="trow">
                  <div className="td td-small">
                    <strong className="subject" />
                  </div>
                  <div className="td td-border-top">
                    <span>
                      <strong className="value">
                        {details.electrolytes['sodium-na'].display_label}
                      </strong>
                      <span className="descriptor">
                        {details.electrolytes['sodium-na'].interpretation}
                      </span>
                    </span>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <RangeChart
                        details={details}
                        index={index}
                        label={'Sodium'}
                        data={this.state.sodiumData}
                      />
                      {!details.electrolytes['sodium-na'].__ok ? (
                        <div className="no-report-data">
                          {`No Data Available`}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-border-top td-extra-small no-mobile-padding">
                    <div className="bucket">
                      <strong className="value">
                        {details.electrolytes['sodium-na'].value}
                      </strong>
                      <span className="descriptor">
                        {details.electrolytes['sodium-na'].unit}
                      </span>
                      {!details.electrolytes['sodium-na'].__ok ? (
                        <div className="no-report-data" />
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-small" />
                </div>

                {/* Biocarbonate */}
                <div className="trow">
                  <div className="td">
                    <strong className="subject" />
                  </div>
                  <div className="td td-border-top">
                    <strong className="value">
                      {details.electrolytes['bicarbonate-t-co-2'].display_label}
                    </strong>
                    <span className="descriptor">
                      {
                        details.electrolytes['bicarbonate-t-co-2']
                          .interpretation
                      }
                    </span>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <RangeChart
                        details={details}
                        index={index}
                        label={'Biocarbonate'}
                        data={this.state.biocarbonate}
                      />
                      {!details.electrolytes['bicarbonate-t-co-2'].__ok ? (
                        <div className="no-report-data">
                          {`No Data Available`}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <strong className="value">
                        {details.electrolytes['bicarbonate-t-co-2'].value}
                      </strong>
                      <span className="descriptor">
                        {details.electrolytes['bicarbonate-t-co-2'].unit}
                      </span>
                      {!details.electrolytes['bicarbonate-t-co-2'].__ok ? (
                        <div className="no-report-data" />
                      ) : null}
                    </div>
                  </div>
                </div>

                {/* Calcium */}
                <div className="trow">
                  <div className="td">
                    <strong className="subject" />
                  </div>
                  <div className="td td-border-top">
                    <strong className="value">
                      {details.electrolytes['calcium-ca-2'].display_label}
                    </strong>
                    <span className="descriptor">
                      {details.electrolytes['calcium-ca-2'].interpretation}
                    </span>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <RangeChart
                        details={details}
                        index={index}
                        label={'Calcium'}
                        data={this.state.calcium}
                      />
                      {!details.electrolytes['calcium-ca-2'].__ok ? (
                        <div className="no-report-data">
                          {`No Data Available`}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="td">
                    <div className="bucket">
                      <strong className="value">
                        {details.electrolytes['calcium-ca-2'].value}
                      </strong>
                      <span className="descriptor">
                        {details.electrolytes['calcium-ca-2'].unit}
                      </span>
                      {!details.electrolytes['calcium-ca-2'].__ok ? (
                        <div className="no-report-data" />
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {!this.props.isMobile && <hr className="gradient-divider" />}
            <div className="lab-group">
              <div className="table">
                {/* Blood Urea */}
                <a
                  href="https://medlineplus.gov/ency/article/003435.htm"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <strong className="subject">Kidney Function</strong>
                  <LinkIcon />
                </a>

                <br />
                {this.props.isMobile && <hr />}

                <br />
                <div className="trow">
                  <div className="td td-small" />
                  <div className="td">
                    <strong className="value">
                      {
                        details.kidney_function['blood-urea-nitrogen-bun']
                          .display_label
                      }
                    </strong>
                    <span className="descriptor">
                      {
                        details.kidney_function['blood-urea-nitrogen-bun']
                          .interpretation
                      }
                    </span>
                  </div>
                  <div className="td">
                    <div className="bucket">
                      <RangeChart
                        details={details}
                        index={index}
                        label={'BloodUrea'}
                        data={this.state.urea}
                      />
                      {!details.kidney_function['blood-urea-nitrogen-bun']
                        .__ok ? (
                        <div className="no-report-data">
                          {`No Data Available`}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-extra-small no-mobile-padding">
                    <div className="bucket">
                      <strong className="value">
                        {
                          details.kidney_function['blood-urea-nitrogen-bun']
                            .value
                        }
                      </strong>
                      <span className="descriptor">
                        {
                          details.kidney_function['blood-urea-nitrogen-bun']
                            .unit
                        }
                      </span>
                      {!details.kidney_function['blood-urea-nitrogen-bun']
                        .__ok ? (
                        <div className="no-report-data" />
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-small" />
                </div>

                {/* Creatine */}
                <div className="trow">
                  <div className="td">
                    <strong className="subject" />
                  </div>
                  <div className="td td-border-top">
                    <strong className="value">
                      {details.kidney_function['creatinine-cre'].display_label}
                    </strong>
                    <span className="descriptor">
                      {details.kidney_function['creatinine-cre'].interpretation}
                    </span>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <RangeChart
                        details={details}
                        index={index}
                        label={'Creatine'}
                        data={this.state.creatinine}
                      />
                      {!details.kidney_function['creatinine-cre'].__ok ? (
                        <div className="no-report-data">
                          {`No Data Available`}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-border-top no-mobile-padding">
                    <div className="bucket">
                      <strong className="value">
                        {details.kidney_function['creatinine-cre'].value}
                      </strong>
                      <span className="descriptor">
                        {details.kidney_function['creatinine-cre'].unit}
                      </span>
                      {!details.kidney_function['creatinine-cre'].__ok ? (
                        <div className="no-report-data" />
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-small" />
                </div>
              </div>
            </div>
            {!this.props.isMobile && <hr className="gradient-divider" />}
            <div className="lab-group">
              <div className="table">
                {/* Glucose */}
                <a
                  href="https://medlineplus.gov/metabolicpanel.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <strong className="subject">Metabolism</strong>
                  <LinkIcon />
                </a>
                <br />
                {this.props.isMobile && <hr />}

                <br />
                <div className="trow">
                  <div className="td td-small" />
                  <div className="td">
                    <strong className="value">
                      {details.metabolism['glucose-glu'].display_label}
                    </strong>
                    <span className="descriptor">
                      {details.metabolism['glucose-glu'].interpretation}
                    </span>
                  </div>
                  <div className="td">
                    <div className="bucket">
                      <RangeChart
                        details={details}
                        index={index}
                        label={'Glucose'}
                        data={this.state.glucose}
                      />
                      {!details.metabolism['glucose-glu'].__ok ? (
                        <div className="no-report-data">
                          {`No Data Available`}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-extra-small no-mobile-padding">
                    <div className="bucket">
                      <strong className="value">
                        {details.metabolism['glucose-glu'].value}
                      </strong>
                      <span className="descriptor">
                        {details.metabolism['glucose-glu'].unit}
                      </span>
                      {!details.metabolism['glucose-glu'].__ok ? (
                        <div className="no-report-data" />
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-small" />
                </div>
              </div>
            </div>
            {!this.props.isMobile && <hr className="gradient-divider" />}

            <div className="lab-group">
              <div className="table">
                {/* Total Protein */}
                <a
                  href="https://medlineplus.gov/liverfunctiontests.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <strong className="subject">Liver Function</strong>
                  <LinkIcon />
                </a>
                <br />
                {this.props.isMobile && <hr />}

                <br />
                <div className="trow">
                  <div className="td td-small" />
                  <div className="td">
                    <strong className="value">
                      {details.liver_function.tp.display_label}
                    </strong>
                    <span className="descriptor">
                      {details.liver_function.tp.interpretation}
                    </span>
                  </div>
                  <div className="td">
                    <div className="bucket">
                      <RangeChart
                        details={details}
                        index={index}
                        label={'TotalProtein'}
                        data={this.state.tp}
                      />
                      {!details.liver_function.tp.__ok ? (
                        <div className="no-report-data">
                          {`No Data Available`}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-extra-small no-mobile-padding">
                    <div className="bucket">
                      <strong className="value">
                        {details.liver_function.tp.value}
                      </strong>
                      <span className="descriptor">
                        {details.liver_function.tp.unit}
                      </span>
                      {!details.liver_function.tp.__ok ? (
                        <div className="no-report-data" />
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-small" />
                </div>

                {/* Albumin */}
                <div className="trow">
                  <div className="td">
                    <strong className="subject" />
                  </div>
                  <div className="td td-border-top">
                    <strong className="value">
                      {details.liver_function.alb.display_label}
                    </strong>
                    <span className="descriptor">
                      {details.liver_function.alb.interpretation}
                    </span>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <RangeChart
                        details={details}
                        index={index}
                        label={'Alb'}
                        data={this.state.alb}
                      />
                      {!details.liver_function.alb.__ok ? (
                        <div className="no-report-data">
                          {`No Data Available`}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <strong className="value">
                        {details.liver_function.alb.value}
                      </strong>
                      <span className="descriptor">
                        {details.liver_function.alb.unit}
                      </span>
                      {!details.liver_function.alb.__ok ? (
                        <div className="no-report-data" />
                      ) : null}
                    </div>
                  </div>
                </div>

                {/* AST */}
                <div className="trow">
                  <div className="td">
                    <strong className="subject" />
                  </div>
                  <div className="td td-border-top">
                    <strong className="value">
                      {details.liver_function.ast.display_label}
                    </strong>
                    <span className="descriptor">
                      {details.liver_function.ast.interpretation}
                    </span>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <RangeChart
                        details={details}
                        index={index}
                        label={'AST'}
                        data={this.state.ast}
                      />
                      {!details.liver_function.ast.__ok ? (
                        <div className="no-report-data">
                          {`No Data Available`}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <strong className="value">
                        {details.liver_function.ast.value}
                      </strong>
                      <span className="descriptor">
                        {details.liver_function.ast.unit}
                      </span>
                      {!details.liver_function.ast.__ok ? (
                        <div className="no-report-data" />
                      ) : null}
                    </div>
                  </div>
                </div>

                {/* ALT */}
                <div className="trow">
                  <div className="td">
                    <strong className="subject" />
                  </div>
                  <div className="td td-border-top">
                    <strong className="value">
                      {details.liver_function.alt.display_label}
                    </strong>
                    <span className="descriptor">
                      {details.liver_function.alt.interpretation}
                    </span>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <RangeChart
                        details={details}
                        index={index}
                        label={'ALT'}
                        data={this.state.alt}
                      />
                      {!details.liver_function.alt.__ok ? (
                        <div className="no-report-data">
                          {`No Data Available`}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <strong className="value">
                        {details.liver_function.alt.value}
                      </strong>
                      <span className="descriptor">
                        {details.liver_function.alt.unit}
                      </span>
                      {!details.liver_function.alt.__ok ? (
                        <div className="no-report-data" />
                      ) : null}
                    </div>
                  </div>
                </div>

                {/* ALP */}
                <div className="trow">
                  <div className="td">
                    <strong className="subject" />
                  </div>
                  <div className="td td-border-top">
                    <strong className="value">
                      {details.liver_function.alp.display_label}
                    </strong>
                    <span className="descriptor">
                      {details.liver_function.alp.interpretation}
                    </span>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <RangeChart
                        details={details}
                        index={index}
                        label={'ALP'}
                        data={this.state.alp}
                      />
                      {!details.liver_function.alp.__ok ? (
                        <div className="no-report-data">
                          {`No Data Available`}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <strong className="value">
                        {details.liver_function.alp.value}
                      </strong>
                      <span className="descriptor">
                        {details.liver_function.alp.unit}
                      </span>
                      {!details.liver_function.alp.__ok ? (
                        <div className="no-report-data" />
                      ) : null}
                    </div>
                  </div>
                </div>

                {/* TBIL */}
                <div className="trow">
                  <div className="td">
                    <strong className="subject" />
                  </div>
                  <div className="td td-border-top">
                    <strong className="value">
                      {details.liver_function.tbil.display_label}
                    </strong>
                    <span className="descriptor">
                      {details.liver_function.tbil.interpretation}
                    </span>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <RangeChart
                        details={details}
                        index={index}
                        label={'TBIL'}
                        data={this.state.tbil}
                      />
                      {!details.liver_function.tbil.__ok ? (
                        <div className="no-report-data">
                          {`No Data Available`}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <strong className="value">
                        {details.liver_function.tbil.value}
                      </strong>
                      <span className="descriptor">
                        {details.liver_function.tbil.unit}
                      </span>
                      {!details.liver_function.tbil.__ok ? (
                        <div className="no-report-data" />
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {!this.props.isMobile && <hr className="gradient-divider" />}

            <div className="lab-group">
              <div className="table">
                {/* Cholestoral Good */}
                <a
                  href="https://medlineplus.gov/ency/patientinstructions/000386.htm"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <strong className="subject">Lipids</strong>
                  <LinkIcon />
                </a>
                <br />
                {this.props.isMobile && <hr />}

                <br />
                <div className="trow">
                  <div className="td td-small" />
                  <div className="td">
                    <strong className="value">
                      {details.lipids.cholesterol.display_label}
                    </strong>
                    <span className="descriptor">
                      {details.lipids.cholesterol.interpretation}
                    </span>
                  </div>
                  <div className="td">
                    <div className="bucket">
                      <RangeChart
                        details={details}
                        index={index}
                        label={'CholDesire'}
                        data={this.state.cholesterol}
                      />
                      {!details.lipids.cholesterol.__ok ? (
                        <div className="no-report-data">
                          {`No Data Available`}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="td no-mobile-padding">
                    <div className="bucket">
                      <strong className="value">
                        {details.lipids.cholesterol.value}
                      </strong>
                      <span className="descriptor">
                        {details.lipids.cholesterol.unit}
                      </span>
                      {!details.lipids.cholesterol.__ok ? (
                        <div className="no-report-data" />
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-small" />
                </div>

                {/* HDL */}
                <div className="trow">
                  <div className="td">
                    <strong className="subject" />
                  </div>
                  <div className="td td-border-top">
                    <strong className="value">
                      {details.lipids.hdl.display_label}
                    </strong>
                    <span className="descriptor">
                      {details.lipids.hdl.interpretation}
                    </span>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <RangeChart
                        details={details}
                        index={index}
                        label={'HDL'}
                        data={this.state.hdl}
                      />
                      {!details.lipids.hdl.__ok ? (
                        <div className="no-report-data">
                          {`No Data Available`}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <strong className="value">
                        {details.lipids.hdl.value}
                      </strong>
                      <span className="descriptor">
                        {details.lipids.hdl.unit}
                      </span>
                      {!details.lipids.hdl.__ok ? (
                        <div className="no-report-data" />
                      ) : null}
                    </div>
                  </div>
                </div>

                {/* Cho HDL */}
                <div className="trow">
                  <div className="td">
                    <strong className="subject" />
                  </div>
                  <div className="td td-border-top">
                    <strong className="value">
                      {details.lipids['cholesterol-hdl'].display_label}
                    </strong>
                    <span className="descriptor">
                      {details.lipids['cholesterol-hdl'].interpretation}
                    </span>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <RangeChart
                        details={details}
                        index={index}
                        label={'ChoHDL'}
                        data={this.state.chdl}
                      />
                      {!details.lipids['cholesterol-hdl'].__ok ? (
                        <div className="no-report-data">
                          {`No Data Available`}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <strong className="value">
                        {details.lipids['cholesterol-hdl'].value}
                      </strong>
                      <span className="descriptor">
                        {details.lipids['cholesterol-hdl'].unit}
                      </span>
                      {!details.lipids['cholesterol-hdl'].__ok ? (
                        <div className="no-report-data" />
                      ) : null}
                    </div>
                  </div>
                </div>

                {/* LDL */}
                <div className="trow">
                  <div className="td">
                    <strong className="subject" />
                  </div>
                  <div className="td td-border-top">
                    <strong className="value">
                      {details.lipids.ldl.display_label}
                    </strong>
                    <span className="descriptor">
                      {details.lipids.ldl.interpretation}
                    </span>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <RangeChart
                        details={details}
                        index={index}
                        label={'LDL'}
                        data={this.state.ldl}
                      />
                      {!details.lipids.ldl.__ok ? (
                        <div className="no-report-data">
                          {`No Data Available`}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <strong className="value">
                        {details.lipids.ldl.value}
                      </strong>
                      <span className="descriptor">
                        {details.lipids.ldl.unit}
                      </span>
                      {!details.lipids.ldl.__ok ? (
                        <div className="no-report-data" />
                      ) : null}
                    </div>
                  </div>
                </div>

                {/* Trig */}
                <div className="trow">
                  <div className="td">
                    <strong className="subject" />
                  </div>
                  <div className="td td-border-top">
                    <strong className="value">
                      {details.lipids.trig.display_label}
                    </strong>
                    <span className="descriptor">
                      {details.lipids.trig.interpretation}
                    </span>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <RangeChart
                        details={details}
                        index={index}
                        label={'TRIG'}
                        data={this.state.trig}
                      />
                      {!details.lipids.trig.__ok ? (
                        <div className="no-report-data">
                          {`No Data Available`}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <strong className="value">
                        {details.lipids.trig.value}
                      </strong>
                      <span className="descriptor">
                        {details.lipids.trig.unit}
                      </span>
                      {!details.lipids.trig.__ok ? (
                        <div className="no-report-data" />
                      ) : null}
                    </div>
                  </div>
                </div>

                {/* VLDL */}
                <div className="trow no-bottom-border">
                  <div className="td">
                    <strong className="subject" />
                  </div>
                  <div className="td td-border-top">
                    <strong className="value">
                      {details.lipids.vldl.display_label}
                    </strong>
                    <span className="descriptor">
                      {details.lipids.vldl.interpretation}
                    </span>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <RangeChart
                        details={details}
                        index={index}
                        label={'VLDL'}
                        data={this.state.vldl}
                      />
                      {!details.lipids.vldl.__ok ? (
                        <div className="no-report-data">
                          {`No Data Available`}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="td td-border-top">
                    <div className="bucket">
                      <strong className="value">
                        {details.lipids.vldl.value}
                      </strong>
                      <span className="descriptor">
                        {details.lipids.vldl.unit}
                      </span>
                      {!details.lipids.vldl.__ok ? (
                        <div className="no-report-data" />
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    )
  }
}

Laboratory.propTypes = {
  details: PropTypes.object.isRequired
}

export default Laboratory
